const NUMERIC_COMPONENT_TYPES = new Set(["NUMBER", "DECIMAL", "QUANTITY", "NUMERIC"]);

export const isNumericComponentType = type => (
  NUMERIC_COMPONENT_TYPES.has(String(type || "").toUpperCase())
);

export const getNumericCellError = ({ rawValue, validation, label }) => {
  if (!validation) return "";

  const value = Number.parseFloat(String(rawValue ?? "").replace(/,/g, ""));
  if (Number.isNaN(value)) return "";

  const minimum = Number(validation.iMinValue);
  if (Number.isFinite(minimum) && minimum > 0 && value < minimum) {
    return validation.sErrorMessage || `${label} must be at least ${minimum}`;
  }

  const maximum = Number(validation.iMaxValue);
  if (Number.isFinite(maximum) && maximum > 0 && value > maximum) {
    return validation.sErrorMessage || `${label} must not exceed ${maximum}`;
  }

  return "";
};
